import { Controller } from "@hotwired/stimulus";
import { makeMatcher } from "../utils/text_match";

// Drives the Learning Center index page (`/juniors/:id/learning_center`).
//
// Features (all client-side — no AJAX, the dataset never exceeds a few
// dozen cards in practice and we don't want a round-trip per keystroke):
//   • Free-text search (title + description, accent-insensitive).
//   • Scope toggle (all / junior / public / in-progress / finished).
//   • Hides empty sections automatically.
//
// Each card encodes its own filter payload in `data-card-filter` (JSON):
//   { title, desc, audience, scope, progress, finished, started }
export default class extends Controller {
  static targets = ["search", "scopeBtn", "card", "section", "emptyHint"];
  static values  = { audience: String };

  connect() {
    this.activeScope = "all";
    this.currentMatcher = makeMatcher("");
    this._refresh();
  }

  search(event) {
    this.currentMatcher = makeMatcher(event.target.value);
    this._refresh();
  }

  switchScope(event) {
    const scope = event.currentTarget.dataset.scope || "all";
    this.activeScope = scope;
    this.scopeBtnTargets.forEach((btn) => {
      btn.classList.toggle("is-active", btn.dataset.scope === scope);
    });
    this._refresh();
  }

  _refresh() {
    let visibleTotal = 0;
    this.cardTargets.forEach((card) => {
      const visible = this._cardMatches(card);
      card.hidden = !visible;
      if (visible) visibleTotal += 1;
    });

    this.sectionTargets.forEach((section) => {
      const visible = section.querySelectorAll('[data-learning-center-hub-target~="card"]:not([hidden])').length > 0;
      section.hidden = !visible;
    });

    if (this.hasEmptyHintTarget) {
      this.emptyHintTarget.hidden = visibleTotal > 0;
    }
  }

  _cardMatches(card) {
    let payload;
    try {
      payload = JSON.parse(card.dataset.cardFilter || "{}");
    } catch (_e) {
      payload = {};
    }

    // Recherche par mots : chaque mot saisi doit se retrouver dans le titre
    // ou la description, quel que soit son rang.
    if (!this.currentMatcher(`${payload.title || ""} ${payload.desc || ""}`)) return false;

    switch (this.activeScope) {
      case "all":
        return true;
      case "je":
        return payload.scope === "je" || payload.scope === "je-public";
      case "public":
        return payload.scope === "public";
      case "in_progress":
        return Boolean(payload.started) && !payload.finished;
      case "finished":
        return Boolean(payload.finished);
      default:
        return true;
    }
  }
}
